import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'

import WaypointSortPreview from './WaypointSortPreview.vue'
import TravelPlanList from '@/components/trip/travelPlan/TravelPlanList.vue'
import LButton from '@/components/core/Button.vue'
import LSpinningLoader from '@/global-components/LSpinningLoader.vue'
import { tripModule, waypointModule } from '@/store'
import { WaypointAlgorithm } from '@/utils/enums'
import { DateRange } from '@/types/trip'
import { useContext } from '@/composables/context'
import { useSelectedTrip } from '@/composables/trip'
import { TransportationType } from '@/types/transportation'

export interface TransportationWaypointSortingPreview {
  _id: string
  type: TransportationType
  label?: string
  isArrivalTransportation?: boolean
  emoji: string
  locationDescription: string
}

interface WaypointPreview {
  _id: string
  name: string
  startDate: DateRange
  endDate: DateRange
  transportations: TransportationWaypointSortingPreview[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WaypointSortingDialog',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {



const { $axios, i18n } = useContext()
const trip = useSelectedTrip()

// State
const isFetching = ref(false)
const isSaving = ref(false)
const waypointsPreview = ref<WaypointPreview[]>([])

const isSortedManually = trip.value.waypointAlgorithm === WaypointAlgorithm.NONE

const title = isSortedManually
  ? i18n.t('waypointSorting.changeToAuto')
  : i18n.t('waypointSorting.changeToManual')

const content = isSortedManually
  ? i18n.t('waypointSorting.changeToAutoDescription')
  : i18n.t('waypointSorting.changeToManualDescription')

const secondaryAction = isSortedManually ? i18n.t('later') : i18n.t('cancel')

onMounted(async () => {
  if (isSortedManually) {
    await fetchPreview()
  }
})

// Methods
async function fetchPreview() {
  isFetching.value = true
  try {
    if (trip.value.userInfo?.useNewTransportationSystem) {
      const { data } = await $axios.get<WaypointPreview[]>(
        `/api/trips/${trip.value._id}/waypoints/optimize/preview`,
      )
      waypointsPreview.value = data
    } else {
      await waypointModule.fetchOptimizationPreview()
    }
  } catch (error) {
    console.error('Failed to fetch waypoint preview:', error)
  } finally {
    isFetching.value = false
  }
}

async function updateTrip() {
  isSaving.value = true

  await tripModule.updateTrip({
    waypointAlgorithm: isSortedManually
      ? WaypointAlgorithm.BY_DATE
      : WaypointAlgorithm.NONE,
  })

  isSaving.value = false
  emit('close')
}

return { __sfc: true,emit, $axios, i18n, trip, isFetching, isSaving, waypointsPreview, isSortedManually, title, content, secondaryAction, fetchPreview, updateTrip, WaypointSortPreview, TravelPlanList, LButton, LSpinningLoader }
}

})